import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import TitleComponent from './TitleComponent';
import EndorsementItem from './EndorsementItem';
import { createEmptyEndorsement } from './EndorsementUtils';
import CONTRACT_INPUT_LABEL_PROPS from './inputs/contractInputLabelProps';

const EndorsementComponent = ({
  endorsements,
  addEndorsement,
  removeEndorsement,
  updateEndorsement,
  availableEndorsements = [],
  mandatoryEndorsementRut,
}) => {
  const [expandedId, setExpandedId] = useState(null);

  const availableToSelect = availableEndorsements.filter(
    (e) => !endorsements.some((end) => String(end.id) === String(e.id)),
  );

  const handleSelectEndorsement = (event) => {
    const { value } = event.target;
    if (value === '' || value == null) return;

    const newEndorsement = availableEndorsements.find(
      (e) => String(e.id) === String(value),
    );
    if (newEndorsement) {
      addEndorsement(newEndorsement);
      setExpandedId(newEndorsement.id);
    }
  };

  const handleAddAnother = () => {
    const newEndorsement = createEmptyEndorsement();
    addEndorsement(newEndorsement);
    setExpandedId(newEndorsement.id);
  };

  const handleRemove = (id) => {
    const endorsement = endorsements.find((e) => String(e.id) === String(id));
    if (mandatoryEndorsementRut && endorsement?.rut === mandatoryEndorsementRut) {
      return;
    }
    removeEndorsement(id);
    if (expandedId === id) {
      setExpandedId(null);
    }
  };

  return (
    <>
      <TitleComponent number="3" label="Avales/Fiadores:" />
      <Stack spacing={2} sx={{ px: 2 }}>
        {availableToSelect.length > 0 && (
          <TextField
            select
            fullWidth
            label="Seleccionar"
            value=""
            onChange={handleSelectEndorsement}
            SelectProps={{ displayEmpty: true }}
            InputLabelProps={CONTRACT_INPUT_LABEL_PROPS}
          >
            <MenuItem value="" disabled sx={{ display: 'none' }} />
            {availableToSelect.map((e) => (
              <MenuItem key={e.id} value={e.id}>
                {e.name}
              </MenuItem>
            ))}
          </TextField>
        )}

        {endorsements.map((endorsement) => (
          <EndorsementItem
            key={endorsement.id}
            endorsement={endorsement}
            expanded={expandedId === endorsement.id}
            onExpandedChange={(isExpanded) => {
              setExpandedId(isExpanded ? endorsement.id : null);
            }}
            onUpdate={updateEndorsement}
            onRemove={handleRemove}
            canRemove={endorsement.rut !== mandatoryEndorsementRut}
          />
        ))}

        <Stack direction="row" justifyContent="flex-end">
          <Link
            component="button"
            type="button"
            variant="body2"
            underline="always"
            onClick={handleAddAnother}
            sx={{ cursor: 'pointer' }}
          >
            + Agregar otro
          </Link>
        </Stack>
      </Stack>
    </>
  );
};

EndorsementComponent.propTypes = {
  endorsements: PropTypes.arrayOf(PropTypes.shape).isRequired,
  addEndorsement: PropTypes.func.isRequired,
  removeEndorsement: PropTypes.func.isRequired,
  updateEndorsement: PropTypes.func.isRequired,
  availableEndorsements: PropTypes.arrayOf(PropTypes.shape).isRequired,
  mandatoryEndorsementRut: PropTypes.string,
};

EndorsementComponent.defaultProps = {
  mandatoryEndorsementRut: null,
};

export default EndorsementComponent;
